<div class="modal-container">

  <div class="modal-header modal-book  d-inline-block">
    <div class="">
        <button class="text-right w-100 modal-clost-btn" (click)="bsModalRef?.hide(); close()" aria-label="Close">&times;</button>
        <h4>Hi there!</h4>
        <p class="mb-5 sub-text">Would you like to make an enquiry<br> for a booking 
            for more than 21 nights?
        </p>
        <div class="mb-4 d-flex  gap-3 resend">
          <button class="btn btn-stripe " (click)="bsModalRef?.hide()" >No</button>
          <button class="btn btn-resend " (click)="goToEnquiry()">Yes</button>
        </div>
      </div>
    
  </div>
